import React from 'react'
import { StyledSearchBackToDealerLink } from './search-back-to-dealer-link.styles'

// eslint-disable-next-line import/no-webpack-loader-syntax
import { IconArrowLeft } from '@at/design-system-icons'

interface SearchBackToDealerLinkProps {
    link: string
}

export const SearchBackToDealerLink = ({ link }: SearchBackToDealerLinkProps) => {
    return (
        <StyledSearchBackToDealerLink href={link} data-testid="back-to-retailer-link" rel="external">
            <IconArrowLeft title="Back to retailer" size={18} viewBox="0 -6 24 24" />
            {`Back to retailer`}
        </StyledSearchBackToDealerLink>
    )
}
